<!-- 图文信息分页展示列表：模块头+图片+标题+分页 -->
<template>
<div class="content-block">
  <div class="info-list-title" v-if="showTitle">
    <span>{{title}}</span>
    <label>{{label}}</label>
    <a href="#" v-if="showMore">更多</a>
    <div class="title-search-div"  v-if="showSearch">
      <input type="text" name="title-search" class="title-search-input" v-model="keyWord" placeholder="输入关键字搜索"/><a @click="titleSearch()" class="title-search-button"></a>
    </div>
  </div>
  <div class="info-list-content">
    <ul  :class="tabClass" v-if="tabList.length>0">
      <li v-for="(tab, index) in tabList" v-bind:class="['list-tab-li',tab.type==selectTab ?'li-active' : '']" v-on:click="selectedAct(tab.type)">{{tab.title}}</li>
    </ul>
    <ul  class="list-order-ul" v-if="showOrder">
      <li class="list-order-li-label">排序：</li>
      <li class="list-order-li">最热门</li>
      <li class="list-order-li">综合</li>
      <li class="list-order-li">最新</li>
      <li class="list-order-li-total">找到相关仓库83个<1/9></li>
    </ul>
    <ul>
      <li v-for="info in infoPage.list">
          <component :is="infoBlock" :info="info"/></component>
      </li>
    </ul>
    <div class="no-record" v-if="infoPage.list.length<1">暂无数据</div>
    <pagination :page="infoPage"  v-on:queryData="queryPage"/>
  </div>
</div>
</template>

<script>
import Pagination from '../utils/Pagination'

export default {
  name: 'InfoPageList01',
  components:{'pagination':Pagination},
  props: {
    showTitle: {
      type: Boolean,
      default: false
    },
    showMore: {
      type: Boolean,
      default: true
    },
    showSearch: {
      type: Boolean,
      default: false
    },
    showOrder: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    titleLength: {
      type: String,
      default: '16'
    },
    label: {
      type: String,
      default: ''
    },
    count: {
      type: String,
      default: '3'
    },
    tabList: {
      type:Array,
      default:function(){return []}
    },
    tabDefaultType: {
      type:String,
      default:'1'
    },
    tabClass: {
      type:String,
      default:'list-tab-ul'
    },
    infoBlock:{
      type:Object,
      default:{}
    },
    infoPage:{
      type:Object,
      default:function(){return {list:[],page:{page:1,total:0,pageSize:10}}}
    }
  },
  data() {
    return {
      keyWord:'',
      selectTab:this.tabDefaultType,
      //newsList:[],
      params: {page:1,pageSize:this.count,type:this.tabDefaultType,keyWord:''},
    }
  },
  methods:{
    selectedAct:function(type){
      this.selectTab=type;
      this.params.type=type;
      this.params.page=1;
      //this.$emit("queryPage",this.params);
      this.queryPage(this.params);
    },
    titleSearch:function(){
      this.params.keyWord=this.keyWord;
      this.params.page=1;
      //this.$emit("queryPage",this.params);
      this.queryPage(this.params);
    },
    queryPage:function(params){
      //console.log("查询分页数据："+JSON.stringify(params));
      this.params=params;
      this.$emit("queryPage",params);
    }
  },
  created:function(){
    //this.newsList=this.Global.newsListDemo.slice(0,this.count);
    //console.log("当前导航页："+this.Global.siteDefaultNav);
    this.queryPage(this.params);
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display:block;
  position:relative;
  margin: 0px 0px 0px 0px;
  padding:0px;
  height:100%;
  text-align:left;
  //background:red;
}
.title-search-div{
  position:relative;
  float:right;
  height:30px;
  width:260px;
  background:green;
  bottom:-9px;
}

.title-search-div .title-search-input {
  display: block;
  float: left;
  width: 220px;
  height: 30px;
  outline-style: none;
  border: 1px solid #dbdbdb;
  border-bottom: 0px solid #dbdbdb;
  font-size: 12px;
  padding-left: 5px;
  background:#dbdbdb;
}

.title-search-div .title-search-button {
  display: block;
  float: left;
  width: 40px;
  height: 30px;
  text-decoration: none;
  background: #515151;
  font-size: 12px;
  color:#ffffff;
  text-align: center;
  line-height: 30px;
  letter-spacing:5px;
  background-image:url(./../../assets/search_1.png);
  background-size: 15px 15px;
  background-repeat: no-repeat;
  background-position: center center;
}

.title-search-button:hover{
  cursor: pointer;
  //background-color: #000;
}

.list-tab-ul {
  display:flex;
  justify-content:flex-start;
  margin: 10px auto;
  width:100%;
  height:40px;
  text-align:center;
  list-style-type: none;
  padding: 5px;
  background:#eee;
}

.list-order-ul{
  display:flex;
  justify-content:flex-start;
  margin: 10px auto;
  width:100%;
  height:40px;
  text-align:center;
  list-style-type: none;
  padding: 5px;
  background:#eee;
}

.list-tab-ul-1 {
  display:flex;
  justify-content:flex-start;
  margin: 10px auto;
  width:100%;
  height:50px;
  text-align:center;
  list-style-type: none;
  padding: 5px 5px 15px 0px;
  border-bottom:1px solid #bbb;
}

.list-tab-ul-1 .list-tab-li{
  float: left;
  margin: 0px 20px 0px 0px;
  height: 30px;
  width: 100px;
  color: #000000;
  font-size: 12px;
  font-weight: 600;
  line-height: 30px;
  text-align: center;
  background: #598118-#BE550F;
}


.list-tab-li {
  float: left;
  margin: 0px 10px 0px 10px;
  height: 30px;
  width: 100px;
  color: #000000;
  font-size: 12px;
  font-weight: 600;
  line-height: 30px;
  text-align: center;
  background: #598118-#BE550F;
}

.list-order-li-label {
  float: left;
  margin: 0px 10px 0px 10px;
  height: 30px;
  width: 40px;
  color: #000000;
  font-size: 12px;
  font-weight: 300;
  line-height: 30px;
  text-align: left;
  background: #598118-#BE550F;
}

.list-order-li {
  float: left;
  margin: 0px 5px 0px 5px;
  height: 30px;
  width: 50px;
  color: #000000;
  font-size: 12px;
  font-weight: 300;
  line-height: 30px;
  text-align: center;
  background: #598118-#BE550F;
}

.list-order-li-total {
  float: right;
  right:0px;
  margin: 0px 5px 0px 315px;
  height: 30px;
  width: 150px;
  color: #000000;
  font-size: 12px;
  font-weight: 300;
  line-height: 30px;
  text-align: center;
}

.list-tab-li:hover{
  cursor: pointer;
  background:#bbb;
  color:#000;
}

.list-order-li:hover{
  cursor: pointer;
  background:#bbb;
  color:#000;
}

.li-active{
  color: #ffffff!important;
  background: #598118;
  background: -moz-linear-gradient(left,  #598118 50%, #BE550F 100%);
  background: -webkit-gradient(linear, left top, left bottom, color-stop(50%,#BE550F), color-stop(100%,#BE550F));
  background: -webkit-linear-gradient(left,  #598118 f0%,#BE550F 100%);
  background: -o-linear-gradient(left,  #598118 f0%,#BE550F 100%);
  background: -ms-linear-gradient(left,  #598118 f0%,#BE550F 100%);
  background: linear-gradient(to right,  #598118 f0%,#BE550F 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#598118', endColorstr='#BE550F',GradientType=0 );
}

</style>



// WEBPACK FOOTER //
// src/components/block/InfoPageList02.vue